<template>
  <div
    v-if="
      $route.name ==  'home' ||
      $route.name == 'user' ||
      $route.name == 'cart' ||
      $route.name == 'order' ||
      $route.name == 'searchProduct' ||
      $route.name == 'search' ||
      $route.name == 'messageCenter' ||
      $route.name == 'messageContent' ||
      $route.name == 'invoiceInfo' ||
      $route.name == 'viewInvoice' ||
      $route.name == 'collection' ||
      $route.name == 'placeAnOrder' ||
      $route.name == 'customerList' ||  $route.name == 'sddl' ||$route.name == 'unitCollection' ||
      $route.name == 'unitInformationCollection'
    "
  >
    <van-tabbar v-model="active" active-color="#2f72f3" inactive-color="#000">
      <van-tabbar-item v-show="this.$appConfig.roleState" icon="home-o" type="danger" replace to="/home" >
        非单位收款
      </van-tabbar-item> 

      <van-tabbar-item v-show="this.$appConfig.roleState" icon="home-o" type="danger" replace to="/unitCollection" >
        单位收款
      </van-tabbar-item> 

      <van-tabbar-item v-show="!this.$appConfig.roleState" icon="home-o" type="danger" replace to="/customerList">
        收集
      </van-tabbar-item>
      <van-tabbar-item v-show="this.$appConfig.roleState" icon="search" replace to="/order">订单</van-tabbar-item>
<!--      <van-tabbar-item-->
<!--        icon="chat-o"-->
<!--        :badge="counts < 1 ? null : counts > 99 ? '99+' : counts"-->
<!--        replace-->
<!--        to="/messageCenter"-->
<!--        @change="information"-->
<!--        >消息</van-tabbar-item-->
<!--      >-->
      <van-tabbar-item icon="user-o" replace to="/user">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import {Badge, Dialog, Tabbar, TabbarItem} from "vant";

Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Badge);
export default {
  name: "tabbar",
  data() {
    return {
      role:'',
      active: 0,
      counts: 0,
      tabbarList: [
        {
          path: "/search",
          title: "分类",
          normal:
              "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-xx.png",
          active:
              "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-xx2.png",
        },
        {
          path: "/cart",
          title: "购物车",
          normal:
              "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-xx.png",
          active:
              "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-xx2.png",
        },
        {
          path: "/person",
          title: "我的",
          normal:
              "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-wd.png",
          active:
              "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-wd2.png",
        },
      ],
    };
  },
  mounted() {
    this.init()
  },
  //监听路由变化
  watch: {
    $route(to) {
      this.activeTab(to.path);
      this.information();
    },
  },

  methods: {
    init(){
      // if(localStorage.getItem("role")==="录入人员"){
      //   this.tabbarList.unshift(
      //     {
      //       path: "/home",
      //       title: "收款",
      //       normal:
      //           "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-fx2.png",
      //       active:
      //           "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-fx.png",
      //     })
      // }else{
      //   this.tabbarList.unshift(
      //     {
      //       path: "/home",
      //       title: "收款",
      //       normal:
      //           "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-fx2.png",
      //       active:
      //           "https://sucai.suoluomei.cn/sucai_zs/images/20190910093117-fx.png",
      //     })
      // }
    },
    information() {
      let roleName = sessionStorage.getItem("router_name");
      if (roleName != null && roleName != "login" && roleName != "loginjudge"&&roleName!='institutionsCollection') {
        var url = "/memberBusiness/information/informationList";
        this.$axios.get(url, { msgaction: 0 }).then((res) => {
          this.counts = res.data.length;
        });
      }
    },
    activeTab(path) {
      console.log(path);
      if(path==="/login"||path==='/home'||path==='/order'||path==='/unitCollection'||path==='/user'){
        var index = this.tabbarList.map((item) => item.path).indexOf(path);
        if (index != -1) {
          this.active = index;
        }
      }else{
          var index = this.tabbarList.map((item) => item.path).indexOf(path);
          if (index != -1) {
            this.active = index;
          }
      }
    },
  },
};
</script>